/* eslint-disable prettier/prettier */
import * as React from 'react'
import { Autocomplete, ListSubheader, TextField, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { COLOR } from 'constant'
import { SvgCarretDownIcon } from 'components/common/LeftPanel/LeftPanel.styled'

const useStyles = makeStyles({
  option: {
    '&:hover': {
      backgroundColor: `${COLOR.TEXT} !important`,
    },
  },
})

const AdhocCountriesSearchDropdown: React.FC<{
  value: any
  id: string
  size: any
  width?: number
  height?: number
  fontSize?: number
  handleStateUpdate?: Function
  isTableView?: boolean
  data: { value: string; isAdhocCountry: boolean }[]
  disablePortal?: boolean
}> = ({
  value,
  width = 220,
  height = 40,
  handleStateUpdate = () => { },
  data,
  id,
  size,
  fontSize = 16,
  disablePortal = true,
}) => {
    const onChange = (event: React.SyntheticEvent, valueParam: any) => {
      handleStateUpdate(event, valueParam)
    }
    const styles = useStyles()

    return (
      <Autocomplete
        disablePortal={disablePortal}
        id={id}
        popupIcon={<SvgCarretDownIcon iconColor={COLOR.CARRET} width='20px' height='20px' />}
        size={size}
        classes={{
          option: styles.option,
        }}
        disableClearable
        isOptionEqualToValue={(option, val) => option.value === val.value}
        sx={{
          mx: 0,
          my: 1,
          width: width,
          position: 'relative',
          '& .MuiAutocomplete-inputRoot': {
            border: `1px solid ${COLOR.DARK}`,
            height: `${height}px !important`,
            borderRadius: '30px !important',
            fontSize: `${fontSize}px !important`,
            color: value.isAdhocCountry ? '#872996' : COLOR.DARK,
            fontFamily: 'CircularStdBook !important',
            paddingTop: height < 40 ? '3px !important' : '6px !important',
          },
          '& .MuiAutocomplete-popupIndicator': {
            transform: 'none',
            background: 'transparent',
            marginTop: '2px',
            '&:focus, &:active': {
              transform: 'rotate(90deg)',
              background: 'transparent',
            },
            '&:hover': {
              backgroundColor: 'transparent',
            },
          },
          '& .MuiAutocomplete-popupIndicatorOpen': {
            transform: 'rotate(90deg)',
          },
        }}
        value={value}
        onChange={onChange}
        options={data}
        getOptionLabel={(option) => {
          return option.value
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            InputProps={{
              ...params.InputProps,
              style: { fontSize: fontSize },
            }}
            value={value}
          />
        )}
        renderOption={(props, option) => {
          const { key, ...optionProps } = props
          return (
            <li
              key={key}
              {...optionProps}
              style={option.isAdhocCountry ? { color: '#872996', fontStyle: 'italic' } : {}}
            >
              {option.value}
            </li>
          )
        }}
        ListboxComponent={(props) => (
          <>
            <ListSubheader disableSticky>
              <Typography
                variant='subtitle2'
                color={COLOR.DARK}
                sx={{ fontSize: '12px', fontStyle: 'italic', margin: '8px 0' }}
              >
                *<span style={{ color: '#872996' }}>Italics</span> indicates countries that are not included in the
                Vibrancy Ranking but for which we have additional data.
              </Typography>
            </ListSubheader>
            <ul {...props} />
          </>
        )}
      />
    )
  }
export default AdhocCountriesSearchDropdown
